'use strict';

const { h } = require('phy');
const { pruneData } = require('../../support/prune-data');

const CouponUber = require('./coupon-uber');
const CouponTile = require('./coupon-tile');
const CategoryRelatedTable = require('../../category/views/category-related');

const AMOUNT_TO_PRELOAD = 4;

function renderItem({ item, index, routes, media, isTouch }) {
  if (item.type === 'related') {
    return CategoryRelatedTable({
      className: item.className,
      parentCategory: item.parentCategory,
      categories: item.categories,
      merchants: item.merchants,
      routes,
      isTouch,
    });
  }

  return CouponTile({
    coupon: item,
    media,
    routes: pruneData(
      routes,
      'outlink:main',
      'redemption:main',
      'redemption:terms',
      'merchant:show'
    ),
    lazy: index >= AMOUNT_TO_PRELOAD,
  });
}

function getItems({ related, coupons }) {
  if (!related.parentCategory) {
    return [...coupons];
  }

  if (coupons.length <= AMOUNT_TO_PRELOAD) {
    return [
      ...coupons,
      {
        type: 'related',
        className: 'category-related-item-last',
        ...related,
      },
    ];
  }

  return [
    ...coupons.slice(0, AMOUNT_TO_PRELOAD - 1),
    {
      type: 'related',
      className: 'category-related-item',
      ...related,
    },
    ...coupons.slice(AMOUNT_TO_PRELOAD),
  ];
}

function getListContent({ coupons, routes, isTouch, media, related }) {
  if (!coupons || !coupons.length) {
    if (related.parentCategory) {
      return CategoryRelatedTable({
        parentCategory: related.parentCategory,
        categories: related.categories,
        merchants: related.merchants,
        routes,
        isTouch,
      });
    }

    return null;
  }

  const items = getItems({ related, coupons });

  return h(
    'ul.coupons-list',
    items.map((item, index) =>
      h(
        'li.coupons-list-row',
        renderItem({ item, index, routes, media, isTouch })
      )
    )
  );
}

function CouponsList({
  premium = [],
  coupons,
  routes,
  isTouch,
  related = {},
  media = 'logo',
  showUberOffer,
  attrs = {},
}) {
  return h(
    '',
    attrs,
    premium.map(coupon =>
      h(
        '.coupons-list-row',
        CouponUber({
          coupon,
          routes: pruneData(
            routes,
            'outlink:main',
            'redemption:main',
            'redemption:terms'
          ),
          showUberOffer,
        })
      )
    ),
    getListContent({
      coupons,
      routes,
      isTouch,
      media,
      related,
    })
  );
}

module.exports = CouponsList;
